export default {
    remove: 'Ta bort',
    save: 'Spara',
    cancel: 'Avbryt',
    loading: 'Laddar…',
    value: 'Värde',
    'action-bar.collapse': 'Dölj',
    'action-bar.expand': 'Visa',
    'action-bar.actions': 'Åtgärder',
    'callout.note': 'Obs',
    'callout.important': 'Viktigt',
    'callout.tip': 'Tips',
    'callout.caution': 'Varning',
    'callout.warning': 'Varning',
    'collapsible-section.open': 'Öppna { header }-sektion',
    'collapsible-section.close': 'Stäng { header }-sektion',
    'date-picker.today': 'Idag',
    'date-picker.month.heading': 'Månad',
    'date-picker.quarter.heading': 'Kvartal',
    'date-picker.year.heading': 'År',
    'chip-set.clear-all': 'Rensa alla',
    'snackbar.dismiss': 'Stäng',
    'file.drag-and-drop-tips':
        'Dra & släpp filen här eller klicka om du vill bläddra.',
    'file-viewer.message.unsupported-filetype':
        'Kan inte visa en förhandsvisning för denna filtyp.',
    'file-viewer.message.try-other-options':
        'Ladda ner filen eller öppna den i en ny flik.',
    'file-viewer.download': 'Ladda ner',
    'file-viewer.exit-fullscreen': 'Avsluta fullskärmsläge',
    'file-viewer.open-in-fullscreen': 'Öppna i fullskärmsläge',
    'file-viewer.open-in-new-tab': 'Öppna i ny flik',
    'file-viewer.more-actions': 'Mer…',
    'editor-menu.bold': 'Fet',
    'editor-menu.italic': 'Kursiv',
    'editor-menu.strikethrough': 'Genomstruken',
    'editor-menu.h1': 'Rubrik 1',
    'editor-menu.h2': 'Rubrik 2',
    'editor-menu.h3': 'Rubrik 3',
    'editor-menu.bulleted-list': 'Punktlista',
    'editor-menu.numbered-list': 'Numrerad lista',
    'editor-menu.blockquote': 'Blockcitat',
    'editor-menu.link': 'Lägg till länk',
    'editor-link-menu.text': 'Text',
    'editor-link-menu.link': 'Länk',
    'editor-menu.code-block': 'Kodblock',
    'editor-menu.code': 'Kod',
    'editor-image-view.loading': 'Laddar bilden: { filename }...',
    'editor-image-view.failed': 'Något gick fel med bilden: { filename }',
    'editor-image-view.success': 'Bilden: { filename } är redo',
    'editor-image-view.resize-handle':
        'Dra åt höger eller vänster för att ändra storlek på bilden',
    'progress-bar': 'Förloppsindikator',
    'ai-avatar.label': 'AI-avatar',
    'ai-avatar.thinking': 'tänker',
    'table.select-all': 'Markera alla rader',
    'table.select-row': 'Markera denna rad',
    'profile-picture.remove': 'Ta bort vald bild',
    'profile-picture.unsupported-preview.title': 'Formatet stöds inte',
    'profile-picture.unsupported-preview.description':
        'Vi kan inte visa den valda bilden i den här webbläsaren. Välj en annan bildfil.',
};
